module.exports = __webpack_public_path__ + "d8d36b3104a411ac446b7a879d8e8528.png";